(() => {
  if (customElements.get('vulgrco-viewport-video')) return;

  class VulgrcoViewportVideo extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.visible = false;
      this.userPaused = false;
      this.autoPause = false;
      this.playPending = false;

      // Set the initial state once; never override a visitor's volume choice.
      if (!this.initialized) {
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.initialized = true;
      }

      this.video.addEventListener('pause', () => {
        if (this.autoPause) {
          this.autoPause = false;
        } else if (this.visible && !document.hidden && !this.video.ended) {
          this.userPaused = true;
        }
      }, { signal });

      this.video.addEventListener('play', () => {
        this.userPaused = false;
        if (!this.visible || document.hidden) this.pauseVideo();
      }, { signal });

      document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting && entry.intersectionRatio > 0;
          this.syncPlayback();
        }, { threshold: [0, 0.01] });
        this.observer.observe(this.video);
      }
    }

    pauseVideo() {
      if (this.video && !this.video.paused) {
        this.autoPause = true;
        this.video.pause();
      }
    }

    async syncPlayback() {
      if (!this.isConnected || !this.visible || document.hidden) {
        this.pauseVideo();
        return;
      }
      if (this.userPaused || this.playPending || !this.video.paused || this.video.ended) return;

      this.playPending = true;
      try {
        await this.video.play();
      } catch (error) {
        // Native controls remain usable if the browser declines autoplay.
      } finally {
        this.playPending = false;
        if (!this.isConnected || !this.visible || document.hidden) this.pauseVideo();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
      this.abortController = null;
      this.visible = false;
      this.pauseVideo();
    }
  }

  customElements.define('vulgrco-viewport-video', VulgrcoViewportVideo);
})();
